export const SET_USER_ADDRESSES = '@app/profile/SET_USER_ADDRESSES';
export const SET_USER_INFO = '@app/profile/SET_USER_INFO';
export const SET_ACTIVE_BOOKINGS_ITEMS = '@app/profile/SET_ACTIVE_BOOKINGS_ITEMS';
export const SET_PREVIOUS_BOOKINGS_ITEMS = '@app/profile/SET_PREVIOUS_BOOKINGS_ITEMS';
export const SET_CITY_INFO = '@app/profile/SET_CITY_INFO';
export const SET_DOWNLOADING_ERROR = '@app/profile/SET_DOWNLOADING_ERROR';
